import React, {useEffect, useState} from "react";

import {
    FormControl,
    FormErrorMessage,
    FormLabel
} from "@chakra-ui/react";
import PasswordComponent from "./PasswordComponent";

/**
 * Form Password Component
 * Props:
 *  id
 *  label,
 *  isRequired,
 *  onChange,
 *  onIsInvalidChange,
 *  validators,
 *  validationErrors
 */
export default function FormPasswordComponent(props) {
    const {
        id,
        label,
        isRequired,
        onChange,
        onIsInvalidChange,
        validators,
        validationErrors
    } = props;
    const [isInvalid, setIsInvalid] = useState(false);
    const [password, setPassword] = useState("");
    const [errors, setErrors] = useState([]);

    useEffect(() => {
        const passwordValidators = validators || [];
        const localErrors = [];
        for (const validator of passwordValidators) {
            const validationErr = validator(password);
            if (validationErr) {
                localErrors.push(validationErr);
            }
        }
        const allErrors = localErrors.concat(validationErrors || []);
        setErrors(allErrors);

        const foundErrors = allErrors.length > 0;
        setIsInvalid(foundErrors);
        if (onIsInvalidChange) {
            onIsInvalidChange(foundErrors);
        }
    }, [password, validationErrors]);

    const onChangeHandler = (value) => {
        setPassword(value);
        if (onChange) {
            onChange(value);
        }
    }

    return (
        <FormControl
            id={id}
            isInvalid={isInvalid}
            isRequired={isRequired}
        >
            <FormLabel>{label}</FormLabel>
            <PasswordComponent
                isInvalid={isInvalid}
                onChange={(value) => onChangeHandler(value)}
            />
            {errors.map((message, index) => (
                <FormErrorMessage key={`${id}_${index}`}>
                    {message}
                </FormErrorMessage>
            ))}
        </FormControl>
    );
}
